/**
 * Resolve the tenant slug for the current portal instance.
 * Priority: VITE_TENANT_SLUG env var → first subdomain → fallback 'tenant1'.
 */
export function getTenantSlug(): string {
  const envSlug = import.meta.env.VITE_TENANT_SLUG as string | undefined;
  if (envSlug) return envSlug;
  const host = window.location.hostname;
  const parts = host.split('.');
  if (parts.length >= 2 && parts[0] !== 'localhost') return parts[0];
  return 'tenant1';
}
